module.exports = __webpack_public_path__ + "img/Refacil.7dca2e14.png";